module.exports = __webpack_public_path__ + "static/media/acero-inoxidable-lamina.bc7fb457.jpg";